import React from 'react';

const ICON_MAP = {
  'its-a-boy': '/category-icons/boy.png',
  'its-a-girl': '/category-icons/girl.png',
  'its-an-upsherin': '/category-icons/upsherin.png',
  'its-a-shidduch': '/category-icons/shidduch.png',
  'its-a-bar-mitzvah': '/category-icons/bar-mitzvah.png',
  'its-something-else': '/category-icons/something-else.png',
};

const BRAND_BLUE = '#29B4F1';
// Language filters render in their own secondary box below the main one.
const LANGUAGE_FILTERS = ['Hebrew', 'Yiddish', 'English'];
const LANGUAGE_LOWER = LANGUAGE_FILTERS.map(s => s.toLowerCase());

export default function CategoryFilterSidebar({ category, selected, onToggle, onClear }) {
  if (!category || !category.filterOptions || category.filterOptions.length === 0) return null;
  const iconSrc = ICON_MAP[category.friendlyUrlName];

  // Split the saved filterOptions into the main category filters and the
  // universal language filters, so we can render them in two separate boxes.
  const mainFilters = category.filterOptions.filter(o => !LANGUAGE_LOWER.includes(String(o).toLowerCase()));
  // Use a fixed Hebrew/Yiddish/English order regardless of how they happen
  // to sit in `filterOptions`. Only show ones that actually exist on the
  // category (so a category without language filters stays as it was).
  const presentLanguages = LANGUAGE_FILTERS.filter(lang =>
    category.filterOptions.some(o => String(o).toLowerCase() === lang.toLowerCase())
  );

  const renderCheckbox = (opt) => (
    <label key={opt}>
      <input
        type="checkbox"
        checked={selected.includes(opt)}
        onChange={() => onToggle(opt)}
        style={{ accentColor: BRAND_BLUE }}
      />
      <span>{opt}</span>
    </label>
  );

  return (
    <aside className="filter-sidebar" style={{ '--filter-color': BRAND_BLUE }}>
      {mainFilters.length > 0 && (
        <div className="filter-sidebar-section">
          <div className="filter-sidebar-header" style={{ background: BRAND_BLUE }}>
            {iconSrc && <img src={iconSrc} alt="" className="sidebar-icon" />}
            <span>{category.name.replace(/^It's (a |an )?/i, '')}</span>
          </div>
          <div className="filter-sidebar-list">
            {mainFilters.map(renderCheckbox)}
          </div>
        </div>
      )}
      {presentLanguages.length > 0 && (
        <div className="filter-sidebar-section">
          <div className="filter-sidebar-subheader">Language</div>
          <div className="filter-sidebar-list">
            {presentLanguages.map(renderCheckbox)}
          </div>
        </div>
      )}
      {selected.length > 0 && (
        <button className="filter-sidebar-clear" onClick={onClear}>Clear filters</button>
      )}
    </aside>
  );
}
